module.exports = __webpack_public_path__ + "img/songfile-landing-bands.11e6e62a.png";